/**
* Overlay plugin declaration
* @desc Controls an overlay component
**/

import Overlay from './Overlay.vue';
import OverlayManager from './OverlayManager.vue';
import module from './module'; // Vuex overlay module

export default {
  install (Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    // Register overlay vuex module 
    options.store.registerModule('overlay', module);

    // Register overlay component
    Vue.component('Overlay', Overlay);
    Vue.component('OverlayManager', OverlayManager);

    // Within the Vue community, it is generally expected that plugins which 
    // modify the Vue prototype prefix any added properties with a dollar sign ($).
    // this is referred to as an instance method

    // Adding $overlay to Vue.prototype allows us to use $overlay within Vue as this.$overlay()
    Vue.prototype.$overlay = {
      /**
      * Add
      * @desc Shows the overlay
      * @param {function} [onClose] - Optional function to run when the overlay closes
      **/
      add: (onClose, zIndex) => {
        options.store.dispatch('addOverlay', { onClose, zIndex });
      },

      /**
      * Remove
      * @desc Shows the overlay
      * @param {function} [onClose] - Optional function to run when the overlay closes
      **/
      remove: () => {
        options.store.dispatch('removeOverlay');

      }
    }
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/overlay/index.js